import { useEffect, useState } from "react";
import { fetchCompanyLocations } from "../Api/ViewCompanyLocationMaster";
import { Container, Table } from "react-bootstrap";
//import "../Styling/ViewCompanyLocationMaster.css";
import { toast } from "react-toastify";
import moment from "moment";

const ViewCompanyLocationMaster = () => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const loadLocations = async () => {
      try {
        const data = await fetchCompanyLocations();
        setLocations(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Company Locations`);
      }
    };

    loadLocations();
  }, []);

  return (
    <>
        <div className="main-content expand">
          <Container fluid className="list-container">
            <h2 className="list-title">View Company Locations</h2>

            {locations.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Company Location ID</th>
                    <th>Registration Number</th>
                    <th>City ID</th>
                    <th>State ID</th>
                    <th>Company Name</th>
                    <th>Created At</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  {locations.map((location, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{location.companyLocationID}</td>
                      <td>{location.registrationNumber}</td>
                      <td>{location.cityId}</td>
                      <td>{location.stateId}</td>
                      <td>{location.companyName}</td>
                      <td>{moment(location.createdAt).format('L')} at {moment(location.createdAt).format('LTS')}</td>
                      <td>{location.createdBy}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No company locations found.</p>
            )}
          </Container>
        </div>
    </>
  );
};

export default ViewCompanyLocationMaster;